/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { isEmpty } from '@ember/utils';
import { action } from '@ember/object';
import { classNames } from '@ember-decorators/component';

@classNames('goals-list', 'layout-column')
export default class GoalsList extends Component {
  @service
  options;

  @service
  router;

  @service
  features;

  @action
  refreshStates() {
    if (!isEmpty(this.subjectStates)) {
      this.subjectStates.update();
    }
  }

  onRouteTransition() {}

  @optionAlias('parents:goals:showGradeLabels')
  showGradeLabel;

  @optionAlias('parents:goals:updatedByPopup')
  showUpdatedByPopup;

  @tracked
  selectedGoal = null;
  @tracked
  showExemplar = false;
  title = '';
  onEditGoals = null;

  @action
  goToRoute(route, params) {
    this.onRouteTransition();
    this.router.transitionTo(route, ...params);
  }

  @action
  onClose() {
    this.showExemplar = false;
  }

  @action
  openExemplar(selectedGoal) {
    this.selectedGoal = selectedGoal;
    this.showExemplar = true;
  }
}
